import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import IncidentTable from './IncidentTable';
import { SelectIncidentConfiguration, ToggleIncConfigDialog } from '../../../actions/IncidentTrackerConfigurationActions.js';

const IncidentStatusTable = (props) => {
	const { className, data, ...rest } = props;
	const dispatch = useDispatch();

	const _incConfigDialogOpen = (rowData, mode) => {
		const item = { id: rowData[0], status: rowData[1] };
		dispatch(SelectIncidentConfiguration({ category: 'status', item }));
		dispatch(ToggleIncConfigDialog(true, mode));
	};

	const _getTableColumns = () => (
		[
			{
				name: 'status',
				label: 'Status',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
		]
	);

	return (
		<IncidentTable
			identifier="incidentStatusTable"
			title="Status"
			data={data}
			customColumns={_getTableColumns()}
			onDeleteClick={(rowData) => _incConfigDialogOpen(rowData, 'Delete')}
			onEditClick={(rowData) => _incConfigDialogOpen(rowData, 'Update')}
		/>
	);
};

IncidentStatusTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default IncidentStatusTable;
